import { Components, Theme } from "@mui/material/styles";

const MuiSkeleton: Components<Theme>["MuiSkeleton"] = {
    styleOverrides: {
        root: {
            backgroundColor: "var(--mui-palette-gray-300)",
        },
        rectangular: {
            borderRadius: "2px",
        },
        rounded: {
            borderRadius: "4px",
        },
    },
};

export { MuiSkeleton };
